const CARDS = [
  {
    icon: 'ri-robot-2-line',
    title: 'AI Assistants Are the New Search',
    body: 'Customers are asking ChatGPT, Perplexity, and other AI assistants for recommendations instead of searching Google.',
    note: "If AI doesn't know your brand, you don't exist.",
  },
  {
    icon: 'ri-cursor-line',
    title: 'Zero-Click Decisions',
    body: 'AI search and answer engines often resolve customer decisions without clicks.',
    note: 'Your brand needs to be in the answer itself — not just ranked on page one.',
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Ads Inside AI Experiences',
    body: 'Ads inside AI conversations are being tested and rolling out across platforms.',
    note: 'Early movers who prepare now will dominate as placements expand.',
  },
];

export default function WhatIsChanging() {
  return (
    <section
      id="changing"
      className="relative py-28 overflow-hidden bg-gradient-to-b from-white via-slate-50 to-white"
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-70"
        style={{ background: 'radial-gradient(ellipse at 80% 10%, rgba(249,115,22,0.12), transparent 55%)' }}
      ></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="eyebrow reveal" style={{ color: '#EA580C', borderColor: 'rgba(249,115,22,0.3)' }}>
            What Is Changing
          </div>
          <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] reveal">
            The Ground Is Shifting<br />Under Local Search.
          </h2>
          <p className="mt-6 text-slate-600 font-body font-light text-base md:text-lg reveal">
            The way customers find and choose businesses is fundamentally shifting — and early movers
            are winning.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {CARDS.map((c) => (
            <div key={c.title} className="glass rounded-2xl p-7 reveal">
              <div className="icon-pill-orange mb-4">
                <i className={`${c.icon} text-orange-500 text-lg`}></i>
              </div>
              <h4 className="h-display text-2xl md:text-3xl leading-tight">{c.title}</h4>
              <p className="mt-3 text-slate-600 font-body font-light text-sm leading-relaxed">{c.body}</p>
              <div className="mt-4 pt-4 border-t border-slate-200 text-xs font-body font-semibold text-orange-600">
                {c.note}
              </div>
            </div>
          ))}
        </div>

        <div className="glass-strong rounded-3xl p-7 md:p-9 mt-8 reveal">
          <div className="flex items-start gap-4">
            <div className="icon-pill shrink-0"><i className="ri-information-line text-teal-500 text-lg"></i></div>
            <div>
              <div className="text-[11px] uppercase tracking-wider text-teal-600 font-body font-bold mb-2">
                Accuracy Note
              </div>
              <p className="text-slate-600 font-body font-light text-sm md:text-base leading-relaxed max-w-3xl">
                OpenAI has announced plans to begin testing ads for eligible Free and Go adult users in
                the U.S.; paid tiers remain ad-free. Availability and formats may evolve as testing
                expands.{' '}
                <strong className="text-slate-800">
                  We help clients prepare and capitalize as new AI ad placements roll out.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
